export default __webpack_public_path__ + "static/Plots0017-3abfbf8a734f486dd9071159707217cb.jpg";